import {ISimplePresentationRunnerController} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {KennethMustDie} from "../KennethMustDie";
import {IFeatureInfo, X_NUDGE_ANIMATIONS} from "../server/IKMDData";
import {KMDSymbol} from "../reels/KMDSymbol";
import {KMDMainReelsXNudgeRunner} from "./KMDMainReelsXNudgeRunner";

export class KMDSpecialRowXNudgeRunner extends KMDMainReelsXNudgeRunner {

    public shouldRun(): boolean {
        return (KennethMustDie.model.xNudgeSpecialRow.length > 0);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const isWin: boolean = KennethMustDie.model.gameData.betWayWins.length > 0,
            tl: gsap.core.Timeline = gsap.timeline({
                delay: 0.2,
                onComplete: () => this.handleComplete(controller, isWin)
            }),
            multipliers: number[][] = KennethMustDie.model.gameData.multiplier,
            xNudgeData: IFeatureInfo[] = KennethMustDie.model.xNudgeSpecialRow;

        this.handleStartOfNudge(isWin, controller, tl);

        xNudgeData.forEach((xNudge: IFeatureInfo) => {
            const animName: string = (X_NUDGE_ANIMATIONS.UP_3_STEP + (isWin ? X_NUDGE_ANIMATIONS.WIN_HELPER : X_NUDGE_ANIMATIONS.NO_WIN_HELPER)),
                nudgeSteps: number = 3,
                xNudgeSymbol: KMDSymbol = KennethMustDie.specialReelView.reel.getStopSymbolAt(xNudge.originSymId).positionable as KMDSymbol,
                multipliersNudgeSteps: number[] = [],
                multipliersYIdx: number[] = [];

            for (let i: number = nudgeSteps - 1; i >= 0; i--) {
                multipliersNudgeSteps.push(multipliers[xNudge.originReelId][i]);
            }

            for (let i: number = 0; i < multipliersNudgeSteps.length - 1; i++) {
                multipliersYIdx.push(-1);
            }
            multipliersYIdx.push(-2);

            tl.add(() => {
                KennethMustDie.reelView.toggleMask(false);
                KennethMustDie.specialReelView.toggleMask(false);
            }, 0);

            if (xNudgeSymbol) {
                xNudgeSymbol.parent.addChild(xNudgeSymbol);
            }

            for (let i: number = 0; i < multipliersNudgeSteps.length; i++) {
                multipliersNudgeSteps[i] = (Math.max(multipliersNudgeSteps[i], 1));
            }

            const nudgeAnim: gsap.core.Timeline = xNudgeSymbol.setState(animName),
                wholeTlDurationTllNow: number = tl.totalDuration();

            this.getNudgeMultiplierAnim(nudgeSteps, tl, nudgeAnim, wholeTlDurationTllNow, multipliersNudgeSteps, isWin, xNudgeSymbol, multipliersYIdx, xNudge.originReelId);
            tl.add(nudgeAnim, wholeTlDurationTllNow);
        });

        if (!isWin) {
            // #370, 200 ms are added even if we timeScale it.
            tl.to(this, {
                duration: 0.2 * 10
            });

            tl.timeScale(10);
        }
    }
}